var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompletingapplication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.5,
    height: 30.5
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9140",
    opacity: 0.75,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7330",
    d: "M15.25 29.75h0a14.5 14.5 0 01-14.5-14.5h0A14.5 14.5 0 0115.25.75h0a14.5 14.5 0 0114.5 14.5h0a14.5 14.5 0 01-14.5 14.5z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "List, Tasks, Checkmark"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7338",
    d: "M24.25 24.25h-18v-18h18z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7339",
    d: "M12.25 20.875h-3",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7340",
    d: "M18.438 15.812A3.188 3.188 0 1115.25 19a3.188 3.188 0 013.188-3.187",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7341",
    d: "M19.677 18.381l-1.549 1.549-.93-.93",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7342",
    d: "M12.25 17.125h-3",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7343",
    d: "M21.25 13.375h-12",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7344",
    d: "M21.25 9.625h-12",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}

export default SvgCompletingapplication;


//////////////////
// WEBPACK FOOTER
// ./src/icons/completing application.svg
// module id = 789
// module chunks = 101